import { GatsbyImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import ReactPlayer from "react-player"
import styled, { css } from "styled-components"
import { motion } from "framer-motion"
import VideoModal from "@components/mb-reviews/video-modal"
import {
  ButtonPlayIcon,
  getMediaQueries,
  useWindowSize,
  mediaBreakpoints,
} from "@abmg-components"

import Icon from "../global/icon"

const size = {
  tablet: 850,
  mini: 768,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const { above } = getMediaQueries()

const CorporateReviewWrapper = styled.div`
  background-color: rgba(248, 250, 252, 1);
  // max-width: 564px;
  margin: 0 auto;
  margin-bottom: 24px;
  overflow: hidden;
  border-radius: 10px 10px 0 0;

  .image-container {
    position: relative;
    ${above.mobile`
      margin-left: 24px;
    `}
    ${above.tablet`
      margin-left: 0;
    `}
  }
  .play-button {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
  }
  ${above.mobile`
    align-items: center;
    display: flex;

  `}
  @media (min-width: 769px) {
    margin-bottom: 64px;
  }
  ${above.tablet`
    flex-direction: column;
  `}
`

const ReviewWrapper = styled.div`
  border: 1px solid var(--ice-grey);
  padding: 0 24px 24px;
  border-radius: 0 0 10px 10px;
  // margin-bottom: 120px;
  ${below.tablet`
  // margin-bottom:80px;
  `}
  ${below.mobile`
  // margin-bottom:68px;
  `}
  background-color: rgba(248, 250, 252, 1);
`
const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  // transform: translateY(-28px);
  ${below.mobile`
    // transform: translateY(-20px);
  `}
`

const Review = styled.p`
  font-size: 22px;
  line-height: 28px;
  color: var(--alt-black);
  margin: 32px 0 16px;
  ${below.mobile`
  margin: 24px 0 16px;
  font-size: 16px;
line-height: 20px;
  `}
`
const Reviewer = styled.div`
  align-self: flex-end;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  text-align: right;
  color: var(--alt-black);
  &.expanded {
    color: ${props => props.quoteColor || null};
  }
  ${below.mobile`
  
  font-size: 16px;
line-height: 20px;
  `}
  ${below.mini`
  text-align: left;
  `}
`
const Source = styled.div`
  align-self: flex-end;
  font-size: 16px;
  line-height: 20px;
  text-align: right;
  color: var(--grey);
  ${below.mini`
  text-align: left;
  `}
  ${below.mobile`
  font-size: 14px;
line-height: 16px;
  `}
`
const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;
`
const IconContainer = styled.div`
  position: relative;
  ${below.mobile`
  svg {
    width:40px;
    height:40px;
  }
  `}/* ::after {
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    width: 42px;
    height: 42px;
    background-color: white;
    border-radius: 50%;
    z-index: -1;
    transform: translate(-1px, -1px);
  } */
`

const VideoReviewCard = props => {
  const [videoActive, setVideoActive] = useState(false)
  const windowWidth = useWindowSize().width
  return (
    <>
      <CorporateReviewWrapper>
        <div className="image-container">
          <ButtonPlayIcon
            functions={{ onClick: () => setVideoActive(true) }}
            circleOpacity={0.8}
            circleWidth={windowWidth < mediaBreakpoints.desktop ? 54 : 64}
            circleHeight={windowWidth < mediaBreakpoints.desktop ? 54 : 64}
          />
          <GatsbyImage image={props.thumbnail} />
        </div>
        <ReviewWrapper>
          <ReviewContainer>
            <Review>{props.review}</Review>
            <Reviewer>{props.reviewer}</Reviewer>
            <Source>
              {props.source
                ? props.source === "BirdEye" || props.source === "Experience"
                  ? "Recent Homebuyer"
                  : props.source
                : "Recent Homebuyer"}
            </Source>
          </ReviewContainer>
        </ReviewWrapper>
      </CorporateReviewWrapper>
      {videoActive && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <VideoModal
            toggleModal={setVideoActive}
            videoID={props.videoId}
            controls
          />
        </motion.div>
      )}
    </>
  )
}

export default VideoReviewCard
